import {
  GetSupplierHearingReplyItemHistoryListRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class HearingReplyItemHistoryListGateway {
  /** 業者ヒアリング回答確認-ステータス履歴取得  */
  static getSupplierHearingReplyItemHistoryList = async (
    simulationYm: string,
    supplierCd: string,
    factoryCd: string,
    expenseCd: string,
    supplierBranchCd: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      factoryCd,
      expenseCd,
      supplierBranchCd
    }
    return await yamadumiApi.get<GetSupplierHearingReplyItemHistoryListRes>(
      '/api/supplier/hearing/reply/item/history/list',
      params
    )
  }
}
